import {VictoryPointType} from '@colonist/game-states'
import SettlementMysticBlue from '@static/images/settlement_mysticblue.svg'
import CityMysticBlue from '@static/images/city_mysticblue.svg'
import StatVp from '@static/images/stat_vp.svg'
import StatLargestArmy from '@static/images/stat_largest_army.svg'
import StatLongestRoad from '@static/images/stat_longest_road.svg'
import StatChits from '@static/images/stat_chits.svg'
import StatMetropolis from '@static/images/stat_metropolis.svg'
import StatDefender from '@static/images/stat_defender.svg'
import StatMerchant from '@static/images/stat_merchant.svg'
import {ImageURL} from '@colonist/types'
import {TranslationKeys} from '@colonist/i18n'

export const VICTORY_POINT_IMAGES: Record<VictoryPointType, ImageURL> = {
    [VictoryPointType.Settlement]: SettlementMysticBlue,
    [VictoryPointType.City]: CityMysticBlue,
    [VictoryPointType.DevelopmentCardVictoryPoint]: StatVp,
    [VictoryPointType.LargestArmy]: StatLargestArmy,
    [VictoryPointType.LongestRoad]: StatLongestRoad,
    [VictoryPointType.Chits]: StatChits,
    [VictoryPointType.Metropolis]: StatMetropolis,
    [VictoryPointType.DefenderOfColonist]: StatDefender,
    [VictoryPointType.ProgressCardVictoryPoint]: StatVp,
    [VictoryPointType.Merchant]: StatMerchant,
}

export const VICTORY_POINT_END_GAME_TIP: Record<VictoryPointType, TranslationKeys> = {
    [VictoryPointType.Settlement]: 'strings:game.endGame.overview.settlementVps',
    [VictoryPointType.City]: 'strings:game.endGame.overview.cityVps',
    [VictoryPointType.DevelopmentCardVictoryPoint]: 'strings:game.endGame.overview.devCardVps',
    [VictoryPointType.LargestArmy]: 'strings:game.endGame.overview.largestArmy',
    [VictoryPointType.LongestRoad]: 'strings:game.endGame.overview.longestRoad',
    [VictoryPointType.Chits]: 'strings:game.endGame.overview.chitVps',
    [VictoryPointType.Metropolis]: 'strings:game.endGame.overview.metropolis',
    [VictoryPointType.DefenderOfColonist]: 'strings:game.endGame.overview.defenderOfColonist',
    [VictoryPointType.ProgressCardVictoryPoint]: 'strings:game.endGame.overview.devCardVps',
    [VictoryPointType.Merchant]: 'strings:game.endGame.overview.merchant',
}
